import { useQueryClient } from '@tanstack/react-query';
import { useFiltersStore } from 'store/useFiltersStore';
import usePropertiesStore from 'store/usePropertiesStore';
import { formatNumber } from 'util/Funcs';
import { FormControlLabel, Switch } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewListIcon from '@mui/icons-material/ViewList';

interface ExportPanelProps {
    isGridView: boolean;
    onViewChange: (isGridView: boolean) => void;
}

const ExportPanel = ({ isGridView, onViewChange }: ExportPanelProps) => {
    const queryClient = useQueryClient();
    const { currentFilter } = useFiltersStore();
    const { currentPage, fetchCompetitorAllPropertiesSort } = usePropertiesStore();

    const data = queryClient.getQueryData(['fetchCompetitorAllProperties', currentPage, currentFilter, fetchCompetitorAllPropertiesSort]) as {
        findAllPropertiesByCompanyIds: { total: number };
    };
    const total = data?.findAllPropertiesByCompanyIds.total ?? 0;
    return (
        <div className="flex justify-between items-center gap-[10px]">
            <div className="text-my-blue font-semibold text-[16px]" data-cy="total-properties-count">{`${formatNumber(total)} property results found`}</div>
            {/* <div className="flex gap-[10px] items-center justify-between">
                <FormControlLabel
                    control={
                        <Switch
                            checked={isGridView}
                            onChange={(e) => onViewChange(e.target.checked)}
                            sx={{
                                '& .MuiSwitch-switchBase': {
                                    color: '#3176bc',
                                    '&:hover': {
                                        backgroundColor: 'rgba(49, 118, 188, 0.08)',
                                    },
                                },
                                '& .MuiSwitch-track': {
                                    backgroundColor: 'rgba(49, 118, 188, 0.3)',
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                    backgroundColor: 'rgba(49, 118, 188, 0.3)',
                                },
                            }}
                        />
                    }
                    label={
                        <div className="flex items-center gap-2">
                            {isGridView ? (
                                <>
                                    <ViewListIcon className="text-my-blue" />
                                    <span className="text-sm text-my-blue">Switch to List View</span>
                                </>
                            ) : (
                                <>
                                    <GridViewIcon className="text-my-blue" />
                                    <span className="text-sm text-my-blue">Switch to Grid View</span>
                                </>
                            )}
                        </div>
                    }
                />
            </div> */}
        </div>
    );
};

export default ExportPanel;
